export default {
  props: {
    error: {
      type: String,
      default: "",
    },
  },
  computed: {
    hasError() {
      return !!this.error;
    },
    errorMessage() {
      return this.error;
    },
  },
};
